import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-remove-session',
  templateUrl: './remove-session.component.html',
  styleUrls: ['./remove-session.component.css']
})
export class RemoveSessionComponent implements OnInit {
  private utility: Utility;
  private redirectToLogin: boolean = true;
  constructor(
    private route: ActivatedRoute,
    private cookieService: CookieService
  ) {

    this.utility = new Utility(this.cookieService);
    this.route.params.subscribe((params) => {
      if (params.Flag != undefined && params.Flag == 1) {
        this.redirectToLogin = false;
      }
    });
  }

  ngOnInit(): void {
    this.utility.ClearAllCookies();
    if (this.redirectToLogin) {
      this.utility.LogOutErp();
    }

  }

}
